import api from "../config/api";

/**
 * Open product detail page by product UUID (uses API host, not frontend origin).
 */
export async function getProductSlug(productId) {
  if (!productId) return null;
  const res = await api.get(`/products/by-id/${productId}`);
  return res.data?.data?.slug || res.data?.slug || null;
}

export async function openProductById(productId, variantId, navigate) {
  try {
    const slug = await getProductSlug(productId);
    if (!slug) return false;

    const path = variantId
      ? `/products/${slug}?variant=${variantId}`
      : `/products/${slug}`;

    if (navigate) {
      navigate(path);
    } else {
      window.open(path, "_blank");
    }
    return true;
  } catch {
    return false;
  }
}
